module.exports = __webpack_public_path__ + "img/a58c01c.jpg";